import { PayPalButtons } from "@paypal/react-paypal-js";


export const PayPalCustom = ({price}) => {
  
    const displayOnly = ["vaultable"];

    function createOrder() {
        return fetch("/my-server/create-paypal-order", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            // use the "body" param to optionally pass additional order information
            // like product ids and quantities
            body: JSON.stringify({
                cart: [
                    {
                        id: "YOUR_PRODUCT_ID",
                        quantity: "YOUR_PRODUCT_QUANTITY",
                        price: ""
                    },
                ],
            }),
        })
            .then((response) => response.json())
            .then((order) => order.id);
    }

    function onApprove(data) {
        return fetch("/my-server/capture-paypal-order", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            orderID: data.orderID
          })
        })
        .then((response) => response.json())
        .then((orderData) => {
              const name = orderData.payer.name.given_name;
              alert(`Transaction completed by ${name}`);
        });

    }
  
    

    return (
        <>
            <PayPalButtons
                style={{ 
                    shape: "pill",
                    layout: "vertical",
                    color: "gold",
                    borderRadius: 10,

                }} 
                displayOnly={displayOnly}
                createOrder={createOrder}
                onApprove={onApprove}
            />

        </>
    )
}
